import { TranslationObject } from './en';

export const langNo: TranslationObject = {
  'common.expected_finish': 'Forventet slutt',
  'common.minutes': 'min',
  'common.now': 'Nå',
  'common.next': 'Neste',
  'common.public_message': 'Offentlig beskjed',
  'common.scheduled_start': 'Planlagt start',
  'common.scheduled_end': 'Planlagt slutt',
  'common.projected_start': 'Forventet start',
  'common.projected_end': 'Forventet slutt',
  'common.stage_timer': 'Scenetimer',
  'common.started_at': 'Startet',
  'common.time_now': 'Klokken nå',
  'common.no_data': 'Ingen data tilgjengelig',
  'countdown.ended': 'Hendelse avsluttet',
  'countdown.running': 'Hendelse pågår',
  'countdown.select_event': 'Velg en hendelse å følge',
  'countdown.to_start': 'Tid til start',
  'countdown.waiting': 'Venter på start',
  'countdown.overtime': 'i overtiden',
  'timeline.live': 'live',
  'timeline.done': 'Ferdig',
  'timeline.due': 'Venter',
  'timeline.followedby': 'Etterfulgt av',
  'project.title': 'Tittel',
  'project.description': 'Beskrivelse',
  'project.backstage_info': 'Backstage-informasjon',
  'project.backstage_url': 'Backstage-URL',
  'project.public_info': 'Offentlig informasjon',
  'project.public_url': 'Offentlig URL',
};
